import { render, staticRenderFns } from "./join_table.vue?vue&type=template&id=37ac5120&scoped=true"
import script from "./join_table.vue?vue&type=script&lang=js"
export * from "./join_table.vue?vue&type=script&lang=js"
import style0 from "./join_table.vue?vue&type=style&index=0&id=37ac5120&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ac5120",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37ac5120')) {
      api.createRecord('37ac5120', component.options)
    } else {
      api.reload('37ac5120', component.options)
    }
    module.hot.accept("./join_table.vue?vue&type=template&id=37ac5120&scoped=true", function () {
      api.rerender('37ac5120', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/sfa/views/activity/activity_program/form/components/join_table.vue"
export default component.exports